export const config = {
    rowSelection: false,
    fieldControl: false,
    columns: [
        {title: '渠道ID', dataIndex: 'channelId', width: 200},
        {title: '渠道名称', dataIndex: 'channelName', width: 300, ellipsis: true},
        {title: '适用角色', dataIndex: 'roleNames', width: 300, ellipsis: true,render:'roleRender'},
        {title: '销售计划名称', dataIndex: 'salesTemplateName', width: 200},
        {title: '操作', dataIndex: 'action', fixed: 'right', width: 120, render: 'actionRender'},
    ],
    footer: [
        {label: '新增', type: 'primary', events: ['onClick:onAdd']}
    ],
    search: [
        {
            name: 'channelIds',
            label: '渠道名称',
            itemType: 'cascader',
            data: 'channelTree',
            key: 'value',
            labelKey: 'label',
            value: 'value',
            allowClear: true,
            showSearch: true,
        },
        {
            name: 'roleIds',
            label: '角色名称',
            itemType: 'select',
            data: 'roleList',
            labelKey: 'name',
            key: 'id',
            mode: 'multiple',
        },
    ]
}
